export default {
  methods: {
    /**
     * @param {string} name
     * @param {string} title
     */
    breadcrumbTitleUpdate (name, title) {
      this.$root.$emit('breadcrumbTitleUpdated', { name, title })
    }
  }
}
